import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils'

export const ClosureEntityList = () => {

  const augRowsReq = (rowsReq) => {
    rowsReq.expr = ExprUtils.isNot('status', 'ACTIVE');
  }
  
  return (
    <EntityList entity="CLOSURE" augRowsReq={augRowsReq} />
  )
}